import TreeSection from './TreeSection';
import {useGetAssignmentsList} from '../../../hooks/corpus/useCorpus';
import {t} from 'i18next';

const Assignments = () => {
  return (
    <TreeSection
      fetchHook={useGetAssignmentsList}
      type={t('corpus.sectionType.assignments')}
    />
  );
};

export default Assignments;
